<template>
    <div :id="`popover-${number}`" class="popover-container">
    <tippy content-tag="div" :allowHTML="true" theme="light" trigger="click" content-class="content-wrapper" :arrow="true" :interactive="true" :onHide="() => $emit('hidePopover')" :onShow="() => $emit('showPopover')">
        <template #default>
            <i class="icon-pencil cursor-pointer" :id="`popover-reactive-${number}`" variant="primary" ref="button" tabindex="0"></i>
        </template>    
        <template #content>
            <div class="tippy-body">
                <slot name="body"></slot>
            </div>
        </template>
    </tippy>
    </div>
</template>

<script>
import { Tippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'
export default {
    name: 'PopoverComponent',
    components: {
        Tippy
    },
    data() {
        return {
            number: this.getRandomInt(1000, 9999),
            showTooltip: false
        }
    },
    methods: {
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
    }
}
</script>

<style scoped>
div {
    float: right;
}
.popover-container{
    margin: auto;
    margin-right: 0px;
}
.cursor-pointer {
    cursor: pointer;
}

/* ----------------------------------------- */
.tippy-body {
    height: auto;
    background-color: white;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
}
</style>
<style>
.tippy-box[data-theme~="light"]{
    box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1),0 4px 80px -8px rgba(36,40,47,.25),0 4px 4px -2px rgba(91,94,105,.15)
}
</style>
